/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDeploymentDto
 */
export interface UpdateDeploymentDto {
    /**
     * The optional name to describe the deployment.
     * @type {string}
     * @memberof UpdateDeploymentDto
     */
    name: string | null;
    /**
     * The ID of the version when an update is made.
     * @type {number}
     * @memberof UpdateDeploymentDto
     */
    versionId: number | null;
    /**
     * The parameters.
     * @type {{ [key: string]: any; }}
     * @memberof UpdateDeploymentDto
     */
    parameters: { [key: string]: any; };
}

/**
 * Check if a given object implements the UpdateDeploymentDto interface.
 */
export function instanceOfUpdateDeploymentDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "versionId" in value;
    isInstance = isInstance && "parameters" in value;

    return isInstance;
}

export function UpdateDeploymentDtoFromJSON(json: any): UpdateDeploymentDto {
    return UpdateDeploymentDtoFromJSONTyped(json, false);
}

export function UpdateDeploymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDeploymentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'versionId': json['versionId'],
        'parameters': json['parameters'],
    };
}

export function UpdateDeploymentDtoToJSON(value?: UpdateDeploymentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'versionId': value.versionId,
        'parameters': value.parameters,
    };
}

